import axios from 'axios';

import { useServicerStore } from '../store';

const SearchService = {
  async search({ query, isLender }) {
    const params = {
      query,
    };

    if (isLender) {
      params.servicer_id = useServicerStore.getState()?.servicerId;
    }

    const response = await axios.get('/search', {
      params,
    });

    return response.data;
  },

  async searchProperty({ query }) {
    const response = await axios.get('/search/property', {
      params: {
        query,
        servicer_id: useServicerStore.getState()?.servicerId,
      },
    });

    return response.data;
  },

  async searchVendors({ query, type }) {
    const response = await axios.get('/search/vendors', {
      params: {
        query,
        type,
        servicer_id: useServicerStore.getState()?.servicerId,
      },
    });

    return response.data;
  },
};

export default SearchService;
